var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15a1.125 1.125 0 100 2.25A1.125 1.125 0 0012 15zM12.75 6.75h-1.5v6.75h1.5V6.75z",
    fill: "#A14211"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5c-.4 0-.8-.152-1.105-.457l-8.938-8.938c-.61-.61-.61-1.6 0-2.21l8.938-8.938c.61-.61 1.6-.61 2.21 0l8.938 8.938c.61.61.61 1.6 0 2.21l-8.938 8.938A1.558 1.558 0 0112 22.5zM12 3a.063.063 0 00-.044.018l-8.938 8.938a.063.063 0 000 .088l8.938 8.938a.063.063 0 00.088 0l8.938-8.938a.063.063 0 000-.088l-8.938-8.938A.063.063 0 0012 2.999z",
    fill: "#A14211"
  })));
}
export default SvgWarningDiamond;